import { Form } from "antd";
import { useState } from "react";
import _ from "lodash";

import { addressFormField } from "./address-form-field";

import FormFactory from "../../../../../../../components/FormFactory";
import HexButton from "../../../../../../../ui-kit/HexButtons";
import { getLabel } from "../../../../../../../hooks/use-labels";
import {
  getSubmissionData,
  onChangeAddressInfo,
} from "../../../../../../Profile/hooks/address-form-helper";

const AddressForm = ({ address, onSave }) => {
  const [form] = Form.useForm();

  const [fields, setFields] = useState(addressFormField(address));
  const [errors, setErrors] = useState({});

  const onChangeHandler = (value, key) => {
    const requestData = {
      value,
      key,
      formFields: fields,
      errors,
    };

    onChangeAddressInfo(requestData, (data) => {
      const { updatedFields, fieldErrors } = data;
      const updatedErrors = { ...errors };
      updatedErrors[key] = "";

      setErrors(fieldErrors);
      setFields(updatedFields);
    });
  };

  const onFinishHandler = () => {
    const { required, fieldsData } = getSubmissionData(fields);
    if (!_.isEmpty(required)) {
      setErrors(required);
    } else {
      onSave(fieldsData);
    }
  };

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onFinishHandler}
      className="address-form-layout"
    >
      <FormFactory
        formElementsTypes={fields}
        onChangeHandler={onChangeHandler}
        errors={errors}
      />

      <HexButton
        label={getLabel("saveLabel")}
        onClick={() => form.submit()}
        type="primary"
        size="lg"
        htmlType="submit"
        className="full-width address-save-button"
      />
    </Form>
  );
};

export default AddressForm;
